import { render } from "./date-group-badge.vue?vue&type=template&id=fd6b8d2c&lang=pug"
import script from "./date-group-badge.vue?vue&type=script&lang=js"
export * from "./date-group-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__